<div class="not-allowed--container">
  <div class="not-allowed--content">
    <p class="cant-see-post">You are not authorized to perform this action on this post.</p>
    <!-- Note: Commenting out => Not yet possible for posts that exist but no permission to view -->
    <!-- <p class="cant-see-post" [innerHTML]="'notify.post.can_t_view_this_post' | translate"></p> -->
  </div>
</div>
